import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import ModuleSwitcher from '@/plugins/module-switcher.js';

Vue.use(VueRouter);

const router = new VueRouter({
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  mode: 'history',
  base: process.env.BASE_URL
})

router.beforeEach(
  (to, from, next) => {
    let query = to.fullPath.match(/^\/$/) ? {} : {redirect: to.fullPath}

    if (to.fullPath.match(/^\/$/) || to.fullPath.match(/^\/home$/)) {
      ModuleSwitcher.redirectIfNeeds();
    }
    ModuleSwitcher.switchModule(to.fullPath);

    // Ensures all pending requests are cancelled on route change
    // Make exclusions for facility tabs
    if (!from.path.includes('/facilities/edit/') && !to.path.includes('/facilities/edit/')) {
      store.dispatch('request/CANCEL_PENDING_REQUESTS');
    }

    // when page is public there are no reasons to check permissions
    if (to.matched.some(record => record.meta.isPublic)) {
      next();
      return;
    }

    //send the user to keycloak login, if not logged in and page is not public
    if (!Vue.$keycloak.authenticated) {
      window.location.replace(Vue.$keycloak.createLoginUrl());
      next();
      return;
    }

    let hasPermission = (to.matched.some(record => record.meta.isMain) && store.getters['auth/isMain'])
    || (to.matched.some(record => record.meta.isAdmin) && store.getters['auth/isAdmin'])
    || (to.matched.some(record => record.meta.isManager) && store.getters['auth/isManager'])
    || (to.matched.some(record => record.meta.isOperator) && store.getters['auth/isOperator'])
    || (to.matched.some(record => record.meta.isViewEmployee) && store.getters['auth/isViewEmployee'])
    || (to.matched.some(record => record.meta.isCustomerMaster) && store.getters['auth/isCustomerMaster'])
    || (to.matched.some(record => record.meta.isFacilityManager) && store.getters['auth/isFacilityManager'])
    || (to.matched.some(record => record.meta.isWorker) && store.getters['auth/isWorker'])
    || !to.matched.some(record => record.meta.isViewEmployee
            || record.meta.isOperator
            || record.meta.isManager
            || record.meta.isAdmin
            || record.meta.isFacilityManager
            || record.meta.isWorker
            || record.meta.isCustomerMaster
            || record.meta.isMain) // Check if at all no constraints
    || !!to.meta.redirectWhenNoAccess;

    if (!hasPermission) {
        next({path: '/403', query: query})
        return
    }

    if (!store.getters['auth/isViewEmployee'] && to.meta.redirectWhenNoAccess) {
      let redirect = router.resolve({name: to.meta.redirectWhenNoAccess});
      next({path: redirect.href, query: query});
      return;
    }

    next()
  }
)

export default router
